import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';

import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Steps} from 'primereact/steps';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputMask} from 'primereact/inputmask';
import {Calendar} from 'primereact/calendar';
import {RadioButton} from 'primereact/radiobutton';
import axios from '../../../axios-url';
import UploadImage from '../../../assets/images/uploadImg.svg';
import { FileUpload } from 'primereact/fileupload';


import { DROPDOWN_CONFIG, SLA_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import SLA from './SLA';
// import Employee from '../../EmployeeServices/Clearance/Departments/Employee/Employee';

class AddSla extends Component {
    state = {
        slaname:"",
        slatype:"",
        description:"",
        schedulespecific:"",
        shift:"",
        validfrom:"",
        validto:"",
        vendorid:"",
        contractno:"",
        supportqueue:"",
        workinholiday:"",
        workinweekend:"",
        isActive:"",
        createdBy:"",
        createdDate:"",
        updatedBy:"",
        updatedDate:"",
        companyId:"414FE8CA-61AA-4876-8FA5-22940150212E",
        drshift: [
            {label : 'Day',value : 1},
            {label : 'Night',value : 2}
        ],
        drvendor: [
            {label : 'FirstOneSystems',value : "c44d175f-f09d-4f86-9299-cf875dc410af"},
            {label : 'AZN',value : 2}
        ],
        drsupportqueue: [
            {label : 'essmss',value : "1"},
            {label : 'Digital Workpermit',value : "2"}
        ], 
        activeIndex:0,       
        stepsItems : [
            {
                label: 'Service Level Agreement',
                command: (event) => {
                    //this.growl.show({severity:'info', summary:'First Step', detail: event.item.label});
                }
            },
            {
                label: 'Escalation',
             
            },
//            {
//                label: 'Document Details',
             
//            },
//            {
//                label: 'Leave Quota',
            
//            }
        ], 
        type : 'add', 
        // sla:{Slaid:null,
        //         slaname:null,
        //         slatype:null,
        //         description:null,
        //         schedulespecific:null,
        //         shift:null,
        //         validfrom:null,
        //         validto:null,
        //         vendorid:null,
        //         contractno:null,
        //         supportqueue:null,
        //         workinholiday:null,
        //         workinweekend:null,
        //         isActive:null,
        //         createdBy:null,
        //         createdDate:null,
        //         updatedBy:null,
        //         updatedDate:null,
        //         companyId:null,
        //     },
        //     escalationList: [
        //         {
        //             id: "",
        //             escalationId: null,
        //             requestMode: null,
        //             stagenum: null,
        //             processid: null,
        //             esclationLevel: 1,
        //             days: null,
        //             hoursMinutes: null,
        //             escalationTo: null,
        //             totalMinutes: null,
        //             isActiv: null,
        //             createdBy: null,
        //             createdDate: null,
        //             updatedBy: null,
        //             updatedDate: null,
        //             companyId: null
        //         }
        //     ]

        // , 
        Employee:[], 
        level:[],
        sla:[],
        loadOnce:true,
        escalationList:[],
        Escalationdb:[],
    }

    
  

    handleChange = (e) => {

        const { name , value } = e.target;

        this.setState({[name]: value});
    }

    statusBodyTemplate = (rowData) => {
        return <span className="">{rowData.status}</span>;
    }

    EscalationAdd = () => {

        let newesc = {escalationId : "00000000-0000-0000-0000-000000000000",esclationLevel : "Level 1", escalationTo:"---Select---",days:"",hoursMinutes:"",processid:this.state.sla.Slaid};
  
        let escValue = [...this.state.Escalation, newesc];
      
        this.setState({Escalation:escValue})
        this.setState({Escalationdb:escValue})        
    }

    LevelEditor = (props) => {
        let level = [
            {label:'Level 1',value:'1'},
            {label:'Level 2',value:'2'},
            {label:'Level 3',value:'3'},
            {label:'Level 4',value:'4'},
            {label:'Level 5',value:'5'}                        
        ];
        if(this.state.level.length===0)
        {
            this.setState({level});
        }
        
        return (
            <Dropdown value={props.value[props.rowIndex].esclationLevel} options={level}
                    onChange={(e) => this.onEditorValueChange(props, e.value)} style={{width:'100%'}} placeholder="---Select---"/>
        );
    }    
    
    docTypeEditor = (props) => {
    //    let types = [
    //        {label:'Passport',value:'Passport'},
    //        {label:'Driving License',value:'Driving License'},
    //        {label:'Iqama',value:'Iqama'}
    //    ];
    let teamMembers = this.state.Employee && this.state.Employee.map((member) => {
        return{
            label:member.label,
            value:member.value,
        }
    }) || [];

        return (
            <Dropdown value={props.value[props.rowIndex].escalationTo} options={teamMembers}
           // onChange={(e) => this.setState({escalationTo: e.target.value})}  placeholder="---Select---"/>
                   onChange={(e) => this.onEditorValueChange(props, e.value)}   style={{width:'100%'}} placeholder="---Select---"/>
                    
        );
    }    
    
    
    
    statusBodyTemplate = (rowData) => {
        return <span className="">{rowData.status}</span>;
    }

     /* Cell Editing */


     getKeyByValue = (object, value) => {
       // return Object.keys(object).find(key => object[key] === value);
       var result = object.find(obj => {
        return obj.value === value
      })

        return result.label;
      }


  
     onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
       
       //updatedValue[props.rowIndex][props.label] = label;        
       
        //this.setState({escalationTo: updatedValue})
        if (props.field=== 'escalationTo')
        {
            let escdb = this.state.Escalationdb;
            escdb[props.rowIndex][props.field] = value;
            escdb[props.rowIndex]['processid'] = this.state.Slaid;
            escdb[props.rowIndex]['CompanyId'] = value;
            this.setState({Escalationdb: escdb});

        const name =  this.getKeyByValue(this.state.Employee,value)
        updatedValue[props.rowIndex][props.field] = name;
        updatedValue[props.rowIndex]['CompanyId'] = value;
   

        this.setState({Escalation: updatedValue});
        }
        else if (props.field=== 'esclationLevel')
        {
            let escdb = this.state.Escalationdb;
            escdb[props.rowIndex][props.field] = value;
            escdb[props.rowIndex]['Createdby'] = value;
            this.setState({Escalationdb: escdb});

        const name =  this.getKeyByValue(this.state.level,value)
        updatedValue[props.rowIndex][props.field] = name;
        this.setState({Escalation: updatedValue});

        }
        else if (props.field=== 'days')
        {
            let escdb = this.state.Escalationdb;
            escdb[props.rowIndex][props.field] = value;
            this.setState({Escalationdb: escdb});

        //const name =  this.getKeyByValue(this.state.level,value)
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({Escalation: updatedValue});

        }
        else if (props.field=== 'hoursMinutes')
        {
            let escdb = this.state.Escalationdb;
            escdb[props.rowIndex][props.field] = value;
            this.setState({Escalationdb: escdb});

       // const name =  this.getKeyByValue(this.state.level,value)
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({Escalation: updatedValue});

        }        
        
        
       //this.setState({escalationTo: name});
    }


//    onEditorValueChange = (props, value) => {
//        let updatedValue = [...props.value];
//        updatedValue[props.rowIndex][props.field] = value;
//        this.setState({documentDetails: updatedValue});
//    }


    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }

    inputCalendarEditor = (props, field) => {
        return <InputMask mask="99/99/9999" slotChar="dd/mm/yyyy" placeholder="Date" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />
        
    }

    issuedEditor =  (props) => {
        return this.inputCalendarEditor(props, 'issuedDate');
    }

    expiryEditor =  (props) => {
        return this.inputCalendarEditor(props, 'expiryDate');
    }

    noEditor1 =  (props) => {
        return this.inputTextEditor(props, 'days');
    }

    noEditor2 =  (props) => {
        return this.inputTextEditor(props, 'hoursMinutes');
    }    

    placeEditor =  (props) => {
        return this.inputTextEditor(props, 'issuedPlace');
    }

    deleteEscalation = (removeIndex) => {

        const updatedEscValue = this.state.Escalation.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({Escalation:updatedEscValue})

    }




    // requiredValidator = (props) => {
    //     let value = props.rowData[props.field];
    //     return value && value.length > 0;
    // }



    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteDocType(rowIndex)}></Button>
        </div>;
    }


    prevMove = () => {
        let currentIndex = this.state.activeIndex;

        let prevValue = currentIndex - 1;

        this.setState({activeIndex:prevValue})

    }

    nextMove = () => {
        let currentIndex = this.state.activeIndex;
        let prevValue = currentIndex + 1;
        this.setState({activeIndex:prevValue})
    }


    componentDidMount(){      
        //this.props.getMasterKeywordList('relationType'); 
        const {  getKeywordValues } = this.props;

        let id = this.props.match.params.id;  
       // if(this.props.tableLists.sla==undefined && this.state.loadOnce && this.props.match.params.type!=="add" )
        this.props.getMasterTableList(`HDS/GetSlaByID?Slaid=${id}&Company_Id=${this.state.companyId}`);  

        getKeywordValues('Employee');//Get Employee Dropdown list
        setTimeout(()=>{  this.props.getMasterKeywordList('Employee'); },1000)

        let type = this.props.match.params.type;
        //this.setState({type:type,activeIndex:0});
        this.setState({type:type});
        this.getAccess = HASACCESS(SLA_SUBMENU_ID);
        if(type !== 'add'){
            this.setState({loading:true});
            setTimeout(()=>{
                if(this.props.tableLists.sla ) 
                {
                    let slad = [];
                    let escald = []
                slad = this.props.tableLists.sla
                    escald = this.props.tableLists.escalationList;
                    this.setState(slad);
                    this.setState(escald);
                    this.setState({Escalationdb:escald});
                }
            //    this.fetchSingleProcess();
               // this.setState({loading:false});
            },1000)
          
        }
        else
        {
            this.setState({loading:false});
        }

    }
  
    // fetchSingleProcess = () =>{

    //     let id = this.props.match.params.id;  
        
    //     let storageItems = [];

    //     //if(this.props.tableLists && this.props.tableLists.length > 0) {
    //     if(this.props.tableLists ) {            
    //         storageItems = this.props.tableLists;
    //         let data = {
    //             Slaid:this.props.match.params.id,
    //             slaname:this.props.tableLists.slaname,
    //             slatype:this.props.tableLists.slatype,
    //             description:this.props.tableLists.description,
    //             schedulespecific:this.props.tableLists.schedulespecific,
    //             shift:this.props.tableLists.shift,
    //             validfrom:this.props.tableLists.validfrom,
    //             validto:this.props.tableLists.validto,
    //             vendorid:this.props.tableLists.vendorid,
    //             contractno:this.props.tableLists.contractno,
    //             supportqueue:this.props.tableLists.supportqueue,
    //             workinholiday:this.props.tableLists.workinholiday,
    //             workinweekend:this.props.tableLists.workinweekend,
    //             isActive:this.props.tableLists.isActive,
    //             createdBy:this.props.tableLists.createdBy,
    //             createdDate:this.props.tableLists.createdDate,
    //             updatedBy:this.props.tableLists.updatedBy,
    //             updatedDate:this.props.tableLists.updatedDate,
    //             companyId:this.props.tableLists.companyId,

    //             }
 
  

    //         this.setState(data);
    //     }

    //     //let type = this.props.match.params.type;
    //    // this.props.getMasterTableList(`HDS/GetSlaByID?Slaid=${id}&Company_Id=${this.state.companyId}`); 

    // }



    componentDidUpdate(){

        // if(this.props.tableLists.sla!==undefined  && this.props.match.params.type!=="add" && this.state.loadOnce) 
        // {
        //     let slad = [];
        //     let escald = []
        //     slad = this.props.tableLists.sla
        //     escald = this.props.tableLists.escalationList;
        //     this.setState({sla:slad});
        //     this.setState({escalationList:escald});
        //     this.setState({loadOnce:false});
        // }

       if(this.props.tableLists.sla!==undefined && this.state.loadOnce && this.props.match.params.type!=="add" ){//&& this.props.tableLists.sla!==undefined && this.state.loadOnce){
           

           //let employee = this.props.tableLists.employee;
          // let sla = this.props.tableLists.sla;

           
           let data = {
               Slaid:this.props.match.params.id,
               slaname:this.props.tableLists.sla.slaname,
               slatype:this.props.tableLists.sla.slatype,
               description:this.props.tableLists.sla.description,
               schedulespecific:this.props.tableLists.sla.schedulespecific,
               shift:this.props.tableLists.sla.shift,
                validfrom:this.props.tableLists.sla.validfrom,
                validto:this.props.tableLists.sla.validto,
                vendorid:this.props.tableLists.sla.vendorid,
                contractno:this.props.tableLists.sla.contractno,
                supportqueue:this.props.tableLists.sla.supportqueue,
                workinholiday:this.props.tableLists.sla.workinholiday,
                workinweekend:this.props.tableLists.sla.workinweekend,
                isActive:this.props.tableLists.sla.isActive,
                createdBy:this.props.tableLists.sla.createdBy,
                createdDate:this.props.tableLists.sla.createdDate,
                updatedBy:this.props.tableLists.sla.updatedBy,
                updatedDate:this.props.tableLists.sla.updatedDate,
                companyId:this.props.tableLists.sla.companyId,

                }
 
  
                this.setState({loadOnce:false});
            this.setState(data);
            let esc = this.props.tableLists.escalationList.map(list => {
                return{
                    escalationId :list.escalationId,
                    esclationLevel :list.createdBy,//list.esclationLevel,
                    escalationTo :list.updatedBy,//list.CompanyId,//list.escalationTo,
                    days :list.days,
                    hoursMinutes :list.hoursMinutes,
                    processid : list.processid,
                    Createdby :this.state.createdBy,
                    Createddate :this.state.createdDate,
                    Updatedby :list.escalationTo,
                    Updateddate :null,
                    CompanyId :"414FE8CA-61AA-4876-8FA5-22940150212E",
                    IsActive :null,
                }
            } ) 

            //let esc = this.props.tableLists.escalationList;
            this.setState({Escalation:esc});
            this.setState({Escalationdb:esc});
       }
    }

  

    add = () => {

        let employee = this.props.tableLists.employee;
        let SlaData = this.props.tableLists.sla;
        //let EmployeeData = {
            let Sla = {  
            Slaid:this.state.Slaid,          
            slaname:this.state.slaname,
            slatype:this.state.slatype,
            description:this.state.description,
            schedulespecific:this.state.schedulespecific,
            shift:this.state.shift,
            validfrom:this.state.validfrom,
            validto:this.state.validto,
            vendorid:this.state.vendorid,
            contractno:this.state.contractno,
            supportqueue:this.state.supportqueue,
            workinholiday:this.state.workinholiday,
            workinweekend:this.state.workinweekend,
            isActive:this.state.isActive,
            createdBy:this.state.createdBy,
            createdDate:this.state.createdDate,
            updatedBy:this.state.updatedBy,
            updatedDate:this.state.updatedDate,
            companyId:this.state.companyId,
        }
        let EscalationList=[];
        if (this.props.match.params.type!=="add")
        {
         EscalationList = this.state.Escalationdb.map(list => {
            return{
                escalationId :list.escalationId,
                esclationLevel :this.state.createdBy, //list.esclationLevel,
                escalationTo :list.CompanyId,//list.escalationTo
                days :list.days,
                hoursMinutes :list.hoursMinutes,
                processid : list.processid,
                Createdby :list.esclationLevel,//this.state.createdBy,
                Createddate :this.state.createdDate,
                Updatedby :list.escalationTo,
                Updateddate :'',
                CompanyId :"414FE8CA-61AA-4876-8FA5-22940150212E",
                IsActive :'',
            }
        } ) 
    }
else
        {

            EscalationList = this.state.Escalationdb.map(list => {
                return{
                    escalationId :list.escalationId,
                    esclationLevel :this.state.createdBy, //list.esclationLevel,
                    escalationTo :list.CompanyId,//list.escalationTo
                    days :list.days,
                    hoursMinutes :list.hoursMinutes,
                    processid : list.processid,
                    Createdby :list.esclationLevel,//this.state.createdBy,
                    Createddate :this.state.createdDate,
                    Updatedby :list.escalationTo,
                    Updateddate :'',
                    CompanyId :"414FE8CA-61AA-4876-8FA5-22940150212E",
                    IsActive :'',
                }
            } ) 

        }
        let SLAMaster = {
            Sla,
            EscalationList,

        }
       // this.props.processDynamicData('employee',this.state.type,finalData,'GetEmployee');
       this.props.processDynamicData('SLA',this.state.type,SLAMaster,'HDS/GetSla');
       //this.props.processDynamicData('Escalation',this.state.EscalationData,EscalationData,'HDS/GetEscalation');

    }
    render() {   

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}
        
        let Employee1 = [];
        if(this.props.Employee && this.props.Employee.length > 0) {
           Employee1 = this.props.Employee;
            if(this.state.Employee.length===0)
            this.setState({Employee:Employee1});
        }
        let sla = [];
        let esc = [];
        if(this.props.sla && this.props.sla.length>0)
        {
            sla=this.props.sla;
            if(this.state.sla.length===0)
            this.setState({sla:sla});
        }
        if(this.props.escalationList && this.props.escalationList.length>0)
        {
            esc=this.props.escalationList;
            if(this.state.escalationList.length===0)
            {
            this.setState({escalationList:esc});
            this.setState({Escalationdb:esc});
            }

        }        

        let grid;
         let firstGrid = (                            
            <div className="p-grid mt1">
 
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">SLA Name <span className="requiredColor">*</span></label>
                    <div className="mt1">
                        <InputText className="p-col-12" name="slaname" onChange={this.handleChange} value={this.state.slaname} placeholder="SLA Name"/>
                    </div>	
                </div>
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Description </label>
                    <div className="mt1">
                        <InputText className="p-col-12" name="description" onChange={this.handleChange} value={this.state.description} placeholder="Description"/>
                    </div>	
                </div>

                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="input">Shift<span className="requiredColor">*</span></label>
                    <div className="mt1">
                            <Dropdown className="p-col-12" options={this.state.drshift} value={this.state.shift} 
                            onChange={e => this.handleChange(e)} placeholder="Select Shift" name="shift" {...DROPDOWN_CONFIG} />
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="input">Vendor Id<span className="requiredColor">*</span></label>
                    <div className="mt1">
                            <Dropdown className="p-col-12" options={this.state.drvendor} value={this.state.vendorid} 
                            onChange={e => this.handleChange(e)} placeholder="Select Vendor" name="vendorid" {...DROPDOWN_CONFIG} />
                    </div>
                </div>                

                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="input">Support Queue<span className="requiredColor">*</span></label>
                    <div className="mt1">
                            <Dropdown className="p-col-12" options={this.state.drsupportqueue} value={this.state.supportqueue} 
                            onChange={e => this.handleChange(e)} placeholder="Select Queue" name="supportqueue" {...DROPDOWN_CONFIG} />
                    </div>
                </div> 
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Contract Number </label>
                    <div className="mt1">
                        <InputText className="p-col-12" name="contractno" placeholder="Select Contract No" onChange={this.handleChange} value={this.state.contractno} />
                    </div>	
                </div>                
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Schedule Specific<span className="requiredColor">*</span></label>
                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value={true} name="schedulespecific" onChange ={this.handleChange} checked={this.state.schedulespecific === true}  />
                            <label htmlFor="rb1" className="p-radiobutton-label">Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value={false} name="schedulespecific" onChange ={this.handleChange} checked={this.state.schedulespecific !== true}/>
                            <label htmlFor="rb1" className="p-radiobutton-label">No</label>
                        </div>
                    </div>
                </div>


                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Work In Holiday?<span className="requiredColor">*</span></label>
                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value= {true}  name="workinholiday" onChange ={this.handleChange} checked={this.state.workinholiday === true}  />
                            <label htmlFor="rb1" className="p-radiobutton-label">Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value={false} name="workinholiday" onChange ={this.handleChange} checked={this.state.workinholiday !== true}/>
                            <label htmlFor="rb1" className="p-radiobutton-label">No</label>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Work In Weekend?<span className="requiredColor">*</span></label>
                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value={true} name="workinweekend" onChange ={this.handleChange} checked={this.state.workinweekend === true}  />
                            <label htmlFor="rb1" className="p-radiobutton-label">Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <RadioButton value={false} name="workinweekend" onChange ={this.handleChange} checked={this.state.workinweekend !== true}/>
                            <label htmlFor="rb1" className="p-radiobutton-label">No</label>
                        </div>
                    </div>
                </div>


                <div className="p-col-12 p-md-6 p-lg-4">
                    <label className="labeltop" htmlFor="textarea">Is Active<span className="requiredColor">*</span></label>
                    <div className="p-grid" style={{ marginTop: '0.5em'}}>
                        <div className="p-col-12 p-md-6">
                        <RadioButton value={true} name="isActive" onChange={e => this.handleChange(e)} checked= {this.state.isActive === true}  />
                        <label htmlFor="rb1" className="p-radiobutton-label">Yes</label>
                        </div>
                        <div className="p-col-12 p-md-6">
                        <RadioButton value={false}  name="isActive" onChange={e => this.handleChange(e)} checked= {this.state.isActive === false}  />
                    <label htmlFor="rb1" className="p-radiobutton-label">No</label>
                        </div>
                    </div>
                </div>

            

            </div>	
        );

        let secondGrid = (
            <>
            <div className="mt3">
                <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
                    <Button label="Add" style={{marginBottom:'10px'}} className="p-button-primary" onClick={this.EscalationAdd}/>
                </div>
        
                <DataTable className="animated fadeIn" rowHover  responsive value={this.state.Escalation} editable={true}>
                <Column field="esclationLevel" header="Escalation Level" editor={this.LevelEditor} style={{height: '3.5em'}}/>
                <Column field="escalationTo" header="Escalate To" editor={this.docTypeEditor} style={{height: '3.5em'}}/>
                <Column field="days" header="Days" editor={this.noEditor1} style={{height: '3.5em'}}/>
                <Column field="hoursMinutes" header="Hours and Minutes" editor={this.noEditor2} style={{height: '3.5em'}}/>
                <Column body={this.actionTemplate} style={{textAlign:'center', width: '8em'}}/>
            </DataTable> 
            </div>
            </>
            
        )        

        if(this.state.activeIndex === 0){
            grid = firstGrid;          
        }else if(this.state.activeIndex === 1){
            grid = secondGrid;
      //  }else if(this.state.activeIndex === 2){
      //      grid = thirdGrid;
      //  }else if(this.state.activeIndex === 3){
      //      grid = fourthGrid;
        }

      
        return (
            <div className="p-grid employeeMaster">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">

                    <div className="card card-w-title">
                        <h1>Add SLA Master</h1>
                    
                        <Steps model={this.state.stepsItems} activeIndex={this.state.activeIndex} onSelect={(e) => this.setState({activeIndex: e.index})} readOnly={false} />

                        { grid }

                        <div className="mt3">
                            <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>

                            { (this.state.activeIndex !== 0) && <Button icon=" pi pi-chevron-left" label="Prev" style={{marginBottom:'10px'}} className="p-button-primary p-button-rounded" onClick={this.prevMove}/> }
                            
                            { (this.state.activeIndex !== (this.state.stepsItems.length-1)) && <Button icon=" pi pi-chevron-right" label="Next" style={{marginBottom:'10px'}} className="p-button-primary p-button-rounded ml1" onClick={this.nextMove}/>}

                            

                            </div>
                        </div>

                        
                    </div>

                    <FooterButton access={accessButton} disabled={false} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/SLA-master/"} />


                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : false,//state.master.loading,
        error : state.master.error,
        success: state.master.success,
        positionList : state.master.positionList,
        tableLists : state.master.tableLists,
        relationType : (state.keyword.relationType!==undefined) ? state.keyword.relationType : [],
        TimeoffType: (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        employeeGroup: (state.keyword.employeeGroup!==undefined) ? state.keyword.employeeGroup : [],
        Department: (state.keyword.Department!==undefined) ? state.keyword.Department : [],
        Division: (state.keyword.Division!==undefined) ? state.keyword.Division : [],
        Section: (state.keyword.Section!==undefined) ? state.keyword.Section : [],
        UnCategorized: (state.keyword.UnCategorized!==undefined) ? state.keyword.UnCategorized : [],
        VicePresident: (state.keyword.VicePresident!==undefined) ? state.keyword.VicePresident : [],
        Employee: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [], 
        Executive: (state.keyword.Executive!==undefined) ? state.keyword.Executive : [],
        sla: (state.master.tableLists.sla!==undefined) ? state.master.tableLists.sla : [],
        escalationList: (state.master.tableLists.escalationList!==undefined) ? state.master.tableLists.escalationList : [],
     
        
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        fetchPositionLists : () => dispatch(actions.fetchPositionLists()),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(AddSla);